import { useState, useEffect } from "react";
import { adminDashboardService } from "../services/adminDashboardService";
export const useDashboardData = () => {
  const [pendingProfiles, setPendingProfiles] = useState(null);
  const [demoProfiles, setDemoProfiles] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const updateData = async () => {
    try {
      setLoading(true);
      const [pending, demo] = await Promise.all([
        adminDashboardService.getOrgAdmins(),
        adminDashboardService.getDemoRequests(),
      ]);
      setPendingProfiles(pending);
      setDemoProfiles(demo);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    updateData();
    const interval = setInterval(updateData, 15000);
    return () => clearInterval(interval);
  }, []);
  return { pendingProfiles, demoProfiles, loading, error, refetch: updateData };
};
